module.exports = __webpack_public_path__ + "img/Uebersicht.1c00d503.png";